import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

// Import Bugsnag configuration
import "./lib/bugsnag.js";
import Bugsnag from "./lib/bugsnag.js";

// Import service worker manager for auto-update functionality
import "./lib/ServiceWorkerManager.js";
// Import version manager for cache busting
import "./lib/VersionManager.js";

// Create Bugsnag ErrorBoundary
const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
